// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bd5ac2d2","488":"4d741736","977":"d07adfeb"}[chunkId] + ".chunk.js";
};